import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
  getAppLayoutBackgroundColor,
  useSidebarDarkMode,
} from "../useAppLayoutAppearance";

function MainContent({ children }) {
  const theme = useTheme();
  const hasMobileAppBar = useMediaQuery(theme.breakpoints.down("md"));
  const sidebarDark = useSidebarDarkMode();
  const backgroundColor = getAppLayoutBackgroundColor(sidebarDark);

  return (
    <Box
      className="MainContent"
      component="main"
      sx={{
        backgroundColor,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        height: "100vh",
        minHeight: "100vh",
        minWidth: 0,
        overflowX: "hidden",
        overflowY: "auto",
        scrollbarColor: `#ccc ${backgroundColor}`,
        scrollbarWidth: "thin",
        width: "100%",
        ...(hasMobileAppBar && {
          maxWidth: "100vw",
          paddingTop: "72px",
        }),
      }}
    >
      {children}
    </Box>
  );
}

export default MainContent;
